export default __webpack_public_path__ + "static/media/newme.051243e0.png";